/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export function showFullScreenMap(expanded) {
    const resultsListRail = document.querySelector('.search-left-rail-wrap');

    const mapRail = document.querySelector('.search-right-rail-wrap');
    if (!expanded) {
        if (resultsListRail) {
            resultsListRail.style.width = '0';
        }
        if (mapRail) {
            mapRail.style.width = '100vw';
        }
    } else {
        if (resultsListRail) {
            resultsListRail.style.width = '';
        }
        if (mapRail) {
            mapRail.style.width = '';
        }
    }
}
